import { IStatistics } from '@/store/models/statistics.model'
import request from '@/utils/request'

export const statisticsRequest = (): Promise<IStatistics> => request<IStatistics>({
    method: 'GET',
    url: '/dataSet/statistics'
})